import { distructAndDispatch } from '@core/utils/methods/destruct-and-dispatch';
import {
  AccountingProjectInformation,
  AccountingSummaryTab,
  ProjectPaceTask,
  User,
} from '@models/interfaces';
import { ProjectActions } from '@store/actions';

export namespace AccountingEffects {
  export const setPaceTasks = distructAndDispatch<
    AccountingSummaryTab,
    ProjectPaceTask[]
  >('paceTasks', ProjectActions.updateProjectPaceTasksAction);

  export const setCurrentProvidenceAgent = distructAndDispatch<
    AccountingProjectInformation,
    User
  >('providenceAgent', ProjectActions.setCurrentProvidenceAgent);
}
